<div class="valor-item">
    <div class="header">
        <h3>{{data.nome}}</h3>
    </div>    
    <div class="content">
        <article [innerHtml]="data.texto | safeHtml"></article>
    </div>    
</div>    